import { Component, MouseEventHandler, useEffect, useRef, useState } from "react";
import { BarContainer, BarLabel, BigHeading, ButtonContainer, DocumentButton, FlexContainer, FormWhiteContainer, LabelContainer, LongBlueButton, OverlayActiveStyle, OverlayBaseContainer, OverlayCloseLogo, OverlaySearchEquipmentContainer, SearchEquipmentContainer, SearchingBoxContainer } from "../../assets/style";
import { Box, Grid, IconButton } from "@mui/material";
import FormDatePicker from "../FormDatePicker";
import FormInput from "../FormInput";
import { deleteIcon, pdfIcon } from "../../assets/imgs";
import dayjs from "dayjs";
import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';
import RecordTable, { TableHeader } from "../RecordTable";
import { useLazyGetEquipmentListQuery, useLazyGetEquipmentTypeDDLQuery, useLazyGetFileQuery } from "../../features/equipment/EquipmentSlice";
import { useNavigate } from "react-router";
import SearchBox from "../SearchBox";
import SearchInput from "../SearchInput";
import SearchDropDownList from "../SearchDropDownList";
import SearchDatePicker from "../SearchDatePicker";
import RecordTableV2 from "../RecordTableV2";
import { RecordModel } from "../../models/RecordModel";
import EquipmentRecordTable from "../EquipmentRecordTable";
import { useTranslation } from "react-i18next";

const EquipmentColumns: TableHeader[] = [
    { field: 'type', headerName: 'Type', width: 200, isSortable: true },
    { field: 'rfid', headerName: 'RFID No.', width: 200, isSortable: false },
    { field: 'equirmentNum', headerName: 'Equipment No.', width: 200, isSortable: false },
    { field: 'equirmentName', headerName: 'Equipment Name', width: 400, isSortable: false },
    { field: 'manufacturer', headerName: 'Brand/ Manufacturer', width: 300, isSortable: true },
    { field: 'modelNum', headerName: 'Model No.', width: 200, isSortable: false },
    { field: 'purchaseDate', headerName: 'Purchase Date', width: 300, isSortable: false },
    { field: 'expiryDate', headerName: 'Expiry Date', width: 300, isSortable: false },
    { field: 'certDueDate', headerName: 'Next Cal. / Cert Due Date', width: 200, isSortable: false },
    { field: 'calPeriod', headerName: 'Cal. Period', width: 200, isSortable: false },
    { field: 'certification', headerName: 'Certification', width: 200, isSortable: false },
    { field: 'qrCode', headerName: 'QR Code', width: 200, isSortable: false },
];
const EquipmentRows = [
    {
        id: 1,
        type: "PPE",
        rfid: "10000",
        equirmentNum: "US-ME-20-111-01",
        equirmentName: "BW Gas Detector, GasAlertMax XT II",
        manufacturer: "BW",
        modelNum: "XT-XWHM-Y-OR",
        purchaseDate: "01/01/2021",
        expiryDate: "01/01/2024",
        certDueDate: "01/01/2024",
        calPeriod: "1 Year",
        certification: "certification 1",
        qrCode: "QR 1",
    },
    {
        id: 2,
        type: "PPE",
        rfid: "20000",
        equirmentNum: "US-ME-20-111-01",
        equirmentName: "BW Gas Detector, GasAlertMax XT II",
        manufacturer: "BW",
        modelNum: "XT-XWHM-Y-OR",
        purchaseDate: "01/01/2021",
        expiryDate: "01/01/2024",
        certDueDate: "01/01/2024",
        calPeriod: "1 Year",
        certification: "certification 1",
        qrCode: "QR 1",
    }
];
export const AddEquipmentContainer = ({ onSelectRows, selectedRows, equipmentTables, workerNum, equipmentType }: any) => {
    const { t, i18n } = useTranslation();
    const [showOverlay, setShowOverlay] = useState(false);

    const toggleOverlay = () => {
        setShowOverlay((prevShowOverlay) => !prevShowOverlay);
    };

    return (
        <div>
            {/* Render other components */}
            <Box sx={{ marginLeft: "8px" }}>
                <LongBlueButton onClick={toggleOverlay}>{t("Add Equipment")}</LongBlueButton>
            </Box>
            {showOverlay && (
                <SearchOnSiteEquipmentOverlay
                    showOverlay={showOverlay}
                    toggleOverlay={toggleOverlay}
                    onSelectRows={onSelectRows}
                    selectedRows={selectedRows}
                    equipmentTables={equipmentTables}
                    workerNum={workerNum}
                    equipmentType={equipmentType}
                />
            )}
        </div>
    );
};
function SearchOnSiteEquipmentOverlay({ showOverlay, toggleOverlay, onSelectRows, selectedRows, equipmentTables, workerNum, equipmentType }: any) {
    //
    const { t, i18n } = useTranslation();
    const [getEquipmentList, equipmentList] = useLazyGetEquipmentListQuery();
    // const [getTypeDDL, typeDDL] = useLazyGetEquipmentListQuery();
    const [getTypeDDL] = useLazyGetEquipmentTypeDDLQuery();
    const [typeDDL, setTypeDDL] = useState([{ id: 0, fullName: "" }]);
    const [getFile, file] = useLazyGetFileQuery();
    // const [type, setType] = useState("");
    const [type, setType] = useState({ id: 0, fullName: "" });
    const [rfid, setRfid] = useState("");
    const [equipmentNum, setEquipmentNum] = useState("");
    const [equipmentName, setEquipmentName] = useState("");
    const [manufacturer, setManufacturer] = useState("");
    const [model, setModel] = useState("");
    const [purchaseDate, setPurchaseDate] = useState(dayjs(null));
    const [expiryDate, setExpiryDate] = useState(dayjs(null));
    const [serialNum, setSerialNum] = useState("");
    const [certDueDate, setCertDueDate] = useState(dayjs(null));
    const navigate = useNavigate();
    const [rows, setRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();
    const [savedRows, setSavedRows] = useState<any[]>([]);

    // const tempType = ([{ id: "PPE", name: "SSS" }, { id: "123", name: "sfsd" }]);
    const columns: TableHeader[] = [
        { field: 'equipmentTypeId', headerName: t("Type"), width: 200, isSortable: true },
        { field: 'rfidNumber', headerName: t("RFID No."), width: 200, isSortable: false },
        { field: 'equipmentNumber', headerName: t("Equipment No."), width: 200, isSortable: false },
        { field: 'equipmentName', headerName: t("Equipment Name"), width: 400, isSortable: false },
        { field: 'manufacturer', headerName: t("Brand / Manufacturer"), width: 300, isSortable: true },
        { field: 'modelNumber', headerName: t("Model No."), width: 200, isSortable: false },
        { field: 'purchaseDate', headerName: t("Purchase Date"), width: 300, isSortable: false },
        { field: 'expiryDate', headerName: t("Expiry Date"), width: 300, isSortable: false },
        { field: 'certDueDate', headerName: t("Next Cal. / Cert Due Date"), width: 200, isSortable: false },
        // { field: 'calPeriod', headerName: 'Cal. Period', width: 200, isSortable: false },
    ];

    // const fileUrl = (Id: string) => {
    //     getFile(Id).then((res) => {
    //         console.log(res);
    //         if (res?.data != undefined) {
    //             const link = document.createElement('a');
    //             link.href = res?.data?.url;

    //             link.click();
    //         }
    //     })
    // }
    const fetchDataForPage2 = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getEquipmentList(
            {
                EquipmentTypeId: type?.fullName != "ALL" && type?.fullName != "" ? type?.id?.toString() : "",
                RfidNumber: rfid?.toString(),
                EquipmentNumber: equipmentNum?.toString(),
                EquipmentName: equipmentName?.toString(),
                Manufacturer: manufacturer?.toString(),
                ModelNumber: model?.toString(),
                SerialNumber: serialNum?.toString(),
                PurchaseDate: purchaseDate?.format("DD/MM/YYYY").toString(),
                ExpiryDate: expiryDate?.format("DD/MM/YYYY").toString(),
                CertDueDate: certDueDate?.format("DD/MM/YYYY").toString(),
                page: pageNumber
            }
        ).then((res) => {
            if (res.status == 'fulfilled') {
                const notContainedData = res.data.records.filter((item: {
                    id: any;
                    equipmentTypeId: any;
                    rfidNumber: any;
                    equipmentNumber: any;
                    modelNumber: any;
                    manufacturer: any;
                    serialNumber: any;
                    purchaseDate: any;
                    expiryDate: any;
                    certDueDate: any;
                    equipmentName: any;
                    certificationFileId: any;
                }) => {
                    // Check if item.id is not contained in equipmentRows
                    // if (equipmentTables)
                    return (
                        !equipmentTables.some((tables: any, index: any) => index != workerNum
                            && tables.some((tableRow: any) => tableRow.id === item.id)
                        )
                    )
                })
                const updatedRows = notContainedData.map((item: any) => {
                    return {
                        id: item.id,
                        equipmentTypeId: item.equipmentTypeId?.id,
                        rfidNumber: item.rfidNumber,
                        equipmentNumber: item.equipmentNumber,
                        equipmentName: item.equipmentName,
                        manufacturer: item.manufacturer,
                        modelNumber: item.modelNumber,
                        purchaseDate: item.purchaseDate,
                        expiryDate: item.expiryDate,
                        certDueDate: item.certDueDate,
                        calPeriod: "N/A",
                        // certification: item.certificationFileId,
                    };
                });
                return updatedRows
            }
        })
        return data;
    };
    const fetchDataForPage = async (pageNumber: any, selectedRows: any) => {
        const data = await getEquipmentList({
            EquipmentTypeId: type?.fullName != "ALL" && type?.fullName != "" ? type?.id?.toString() : "",
            RfidNumber: rfid?.toString(),
            EquipmentNumber: equipmentNum?.toString(),
            EquipmentName: equipmentName?.toString(),
            Manufacturer: manufacturer?.toString(),
            ModelNumber: model?.toString(),
            SerialNumber: serialNum?.toString(),
            PurchaseDate: purchaseDate?.format("DD/MM/YYYY").toString(),
            ExpiryDate: expiryDate?.format("DD/MM/YYYY").toString(),
            CertDueDate: certDueDate?.format("DD/MM/YYYY").toString(),
            page: pageNumber,
        });

        const notContainedData = data.data.records.filter((item: any) => {
            return !equipmentTables.some((tables: any, index: any) => index != workerNum && tables.some((tableRow: any) => tableRow.id === item.id));
        }).filter((tableRow: any) => tableRow.equipmentTypeId == equipmentType);

        const updatedRows = notContainedData.map((item: any) => {

            return {
                id: item.id,
                equipmentTypeId: item.equipmentTypeName,
                rfidNumber: item.rfidNumber,
                equipmentNumber: item.equipmentNumber,
                equipmentName: item.equipmentName,
                manufacturer: item.manufacturer,
                modelNumber: item.modelNumber,
                purchaseDate: item.purchaseDate,
                expiryDate: item.expiryDate,
                certDueDate: item.certDueDate,
                calPeriod: "N/A",
            };
        });

        return updatedRows;
    };
    // const fetchDataForPage = async (pageNumber: any, selectedRows?: any) => {

    //     const data = await getEquipmentList(
    //         {
    //             EquipmentTypeId: type?.toString(),
    //             RfidNumber: rfid?.toString(),
    //             EquipmentNumber: equipmentNum?.toString(),
    //             EquipmentName: equipmentName?.toString(),
    //             Manufacturer: manufacturer?.toString(),
    //             ModelNumber: model?.toString(),
    //             SerialNumber: serialNum?.toString(),
    //             PurchaseDate: purchaseDate?.format("DD/MM/YYYY").toString(),
    //             ExpiryDate: expiryDate?.format("DD/MM/YYYY").toString(),
    //             CertDueDate: certDueDate?.format("DD/MM/YYYY").toString(),
    //             page: pageNumber,
    //         }
    //     );

    //     const notContainedData = data.data.records.filter((item: any) => {
    //         // Check if item.id is not contained in equipmentRows
    //         return !equipmentTables.some((tables: any, index: any) => index != workerNum && tables.some((tableRow: any) => tableRow.id === item.id));
    //     }).filter((tableRow: any) => tableRow.equipmentTypeId == equipmentType);

    //     const updatedRows = notContainedData.map((item: any) => {
    //         return {
    //             id: item.id,
    //             equipmentTypeId: item.equipmentTypeId,
    //             rfidNumber: item.rfidNumber,
    //             equipmentNumber: item.equipmentNumber,
    //             equipmentName: item.equipmentName,
    //             manufacturer: item.manufacturer,
    //             modelNumber: item.modelNumber,
    //             purchaseDate: item.purchaseDate,
    //             expiryDate: item.expiryDate,
    //             certDueDate: item.certDueDate,
    //             calPeriod: "N/A",
    //         };
    //     });

    //     return updatedRows;
    // };

    const handleSearchClick = async () => {
        try {
            getEquipmentList({
                EquipmentTypeId: type?.fullName != "ALL" && type?.fullName != "" ? type?.id?.toString() : "",
                RfidNumber: rfid?.toString(),
                EquipmentNumber: equipmentNum?.toString(),
                EquipmentName: equipmentName?.toString(),
                Manufacturer: manufacturer?.toString(),
                ModelNumber: model?.toString(),
                SerialNumber: serialNum?.toString(),
                PurchaseDate: purchaseDate?.format("DD/MM/YYYY").toString(),
                ExpiryDate: expiryDate?.format("DD/MM/YYYY").toString(),
                CertDueDate: certDueDate?.format("DD/MM/YYYY").toString(),
            }).then((res) => {
                if (res.status == 'fulfilled') {
                    const notContainedData = res.data.records.filter((item: {
                        id: any;
                        equipmentTypeId: any;
                        rfidNumber: any;
                        equipmentNumber: any;
                        modelNumber: any;
                        manufacturer: any;
                        serialNumber: any;
                        purchaseDate: any;
                        expiryDate: any;
                        certDueDate: any;
                        equipmentName: any;
                        certificationFileId: any;
                    }) => {

                        return (
                            !equipmentTables.some((tables: any, index: any) => index != workerNum
                                && tables.some((tableRow: any) => tableRow.id === item.id)
                            )
                        )
                    })
                    const updatedRows = notContainedData.map((item: any) => {
                        return {
                            id: item.id,
                            equipmentTypeId: item.equipmentTypeName,
                            rfidNumber: item.rfidNumber,
                            equipmentNumber: item.equipmentNumber,
                            equipmentName: item.equipmentName,
                            manufacturer: item.manufacturer,
                            modelNumber: item.modelNumber,
                            purchaseDate: item.purchaseDate,
                            expiryDate: item.expiryDate,
                            certDueDate: item.certDueDate,
                            calPeriod: "N/A",
                            // certification: item.certificationFileId,
                        };
                    });
                    setData(res.data)
                    setRows(updatedRows);
                }
            })

        } catch (error) { }
    };


    const handleDDLonChange = (name: string) => {
        const matchType = typeDDL?.find((item: any) => item?.fullName === name);
        if (matchType != undefined) {
            setType(matchType);
            console.log("matchType", matchType)
        }
    }

    useEffect(() => {
        handleSearchClick();
        getTypeDDL().then((res) => {
            if (res.status == 'fulfilled') {
                let ddl = [{ id: 0, fullName: "ALL" }, ...res.data];
                console.log(ddl);
                setTypeDDL(ddl);
            }
        });
    }, [])

    useEffect(() => { console.log("rows", rows, "data", data) }, [rows])
    // const handleRowClick = (equipment: any, field?: string) => {
    //     //console.log(field)
    //     // Handle the row click event and pass the row value to another page or component
    //     if (field != undefined && (field == 'certificationIcon' || field == '__check__')) {
    //         //console.log("Icon Button Click")
    //     }
    //     else {
    //         //console.log(equipment?.equipmentId);
    //         navigate('/equipment-detail', { state: equipment?.equipmentId });
    //     }

    // };
    //

    return (
        <OverlayBaseContainer
            style={showOverlay ? OverlayActiveStyle : {}}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    toggleOverlay();
                }
            }}
        >
            <OverlaySearchEquipmentContainer>
                <SearchEquipmentContainer flexGrow={1}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <BigHeading>{t("Search Equipment")}</BigHeading>
                        <OverlayCloseLogo onClick={toggleOverlay}>
                            <IconButton>
                                <CloseIcon />
                            </IconButton>
                        </OverlayCloseLogo>
                    </div>
                    <SearchingBoxContainer>
                        <SearchBox>
                            <FlexContainer>
                                {/* <FormDropDownList sameRowTitle={"Type"} value={type} handleValueChange={(event: any) => setType(event?.target?.value)} items={tempType.map(item => item.name)} /> */}
                                {/* <SearchDropDownList title={t("Type")} value={type} handleValueChange={(event: any) => setType(event?.target?.value)} items={tempType.map(item => item.name)} /> */}
                                <SearchDropDownList title={(t("Type"))} value={type?.fullName} handleValueChange={(event: any) => handleDDLonChange(event?.target?.value)} items={typeDDL?.map((item: { fullName: any; }) => item.fullName)} />
                                <SearchInput title={t("RFID No.")} value={rfid} setMethod={setRfid} />
                                <SearchInput title={t("Equipment No.")} value={equipmentNum} setMethod={setEquipmentNum} />
                                <SearchInput title={t("Equipment Name")} value={equipmentName} setMethod={setEquipmentName} />
                                <SearchInput title={t("Manufacturer")} value={manufacturer} setMethod={setManufacturer} />
                                <SearchInput title={t("Model")} value={model} setMethod={setModel} />
                                <SearchDatePicker title={t("Purchase Date")} value={purchaseDate} setMethod={setPurchaseDate} />
                                <SearchDatePicker title={t("Expiry Date")} value={expiryDate} setMethod={setExpiryDate} />
                                <SearchInput title={t("Serial No.")} value={serialNum} setMethod={setSerialNum} />
                                <SearchDatePicker title={t("Cert Due Date")} value={certDueDate} setMethod={setCertDueDate} />
                            </FlexContainer>
                            <FlexContainer>
                                <LongBlueButton onClick={handleSearchClick}>{t("Search")}</LongBlueButton>
                            </FlexContainer>
                            {/* <FlexContainer>
                                <LongBlueButton onClick={() => { navigate('/add-equipment') }}>Add New Equipment</LongBlueButton>
                            </FlexContainer> */}
                        </SearchBox>
                    </SearchingBoxContainer>
                    {/* {<RecordTable columns={EquipmentColumns} rows={EquipmentRows} checkbox={true} color="#8BB0DB" onSelectRows={onSelectRows} selectedRows={selectedRows} ></RecordTable>} */}
                    {/* <RecordTable
                        columns={columns}
                        rows={rows}
                        checkbox={true}
                        // color="#8BB0DB"
                        onSelectRows={onSelectRows}
                        selectedRows={selectedRows}
                    /> */}

                    <EquipmentRecordTable
                        columns={columns}
                        rows={rows}
                        checkbox={true}
                        onSelectRows={onSelectRows}
                        selectedRows={selectedRows}
                        pages={data?.totalPages}
                        totalCount={data?.totalCount}
                        updateTableRows={setRows}
                        fetchDataForPage={fetchDataForPage}
                    ></EquipmentRecordTable>
                </SearchEquipmentContainer>
            </OverlaySearchEquipmentContainer>
        </OverlayBaseContainer>
    );
}